<div class="modal-header">
  <button
    *ngIf="!data.disableClose"
    mat-icon-button 
    class="close-btn" 
    id="modal-wrapper-close-btn" 
    type="button" 
    (click)="dialogRef.close(false)"
    [autofocus]="false"
    [attr.aria-label]="'Botão fechar'">
    <mat-icon>close</mat-icon>
  </button>
</div>
<div class="modal-content">
  <mat-icon class="modal-icon material-symbols-outlined">error_outline</mat-icon>
  <div [innerHTML]="data.text" class="text-container">
  </div>
  <div class="actions">
    <button *ngIf="!data.hideDeniedButton" (click)="dialogRef.close(false)" mat-stroked-button class="outlined" color="primary" >
      {{data.deniedBtnText}}
    </button>
    <button (click)="dialogRef.close(true)" [class.fullwidth]="data.hideDeniedButton"  mat-flat-button color="primary" >
      {{data.confirmBtnText}}
    </button>
  </div>
</div>